export default "__VITE_ASSET__BXhCXgxh__"